import 'raty-js';

window.Reverb = window.Reverb || {};

Reverb.DashboardFeedback = (function () {
  const feedbackListContainer = '[data=\'feedback-list\']';
  const starErrorNotice = '.star-error-notice';
  const messageErrorNotice = '.message-error-notice';

  function bindRatyStarsDisplay() {
    $('.raty-star.write').each(function () {
      const $this = $(this);
      const id = $this.attr('rel');
      setupRatyStar(id, $this);
    });
  }

  // Path is hardcoded to production cloudfront due to
  // not being able to read full asset path at runtime
  // in JS — if you ever change this, it also needs to be
  // change in raty.js
  function setupRatyStar(id, element) {
    element.raty({
      click(score) {
        const form = element.closest('form');
        const submit = form.find(':submit');

        form.find(starErrorNotice).slideUp();

        $(`input#rating-${id}`).val(score);
      },
      hints: ['', '', '', '', ''],
      path: '',
      starHalf: 'https://images.reverb.com/image/upload/v1450205868/feedback_half-star_ovwhoi.png',
      starOn: 'https://images.reverb.com/image/upload/v1433195155/star-on-3_kfbbby.png',
      starOff: 'https://images.reverb.com/image/upload/v1433195155/star-off-3_vyhsla.png',
      halfShow: false,
      target: `.raty-star-hint-${id}`,
      targetKeep: true,
    });
  }

  function showStarError(form) {
    form.find(starErrorNotice).slideDown();
  }

  function showMessageError(form) {
    form.find(messageErrorNotice).slideDown();
  }

  function hideMessageError(form) {
    form.find(messageErrorNotice).slideUp();
  }

  function bindFeedbackSubmit() {
    $(feedbackListContainer).on('submit', 'form', handleFeedbackSubmission);
  }

  function textAreaLength($textArea) {
    const text = $textArea.val();
    const newLines = text.match(/(\r\n|\n|\r)/g);

    let additionalLength = 0;
    if (newLines != null) {
      additionalLength = newLines.length;
    }
    return text.length + additionalLength;
  }

  function bindMessageInput() {
    $('[data-max-message-length]').on('input', function () {
      const $this = $(this);
      const $form = $this.parents('form');
      const length = textAreaLength($this);
      if (length >= $this.prop('maxlength')) {
        showMessageError($form);
      } else {
        hideMessageError($form);
      }
    });
  }

  function handleFeedbackSubmission(e) {
    e.preventDefault();
    const $form = $(this);
    if ($form.find('[name="feedback[rating]"]').val().length === 0) {
      showStarError($form);
      return false;
    }
    submitFeedback($form);
  }

  function submitFeedback(form) {
    $.ajax({
      type: 'POST',
      url: form.attr('action'),
      data: form.serialize(),
      dataType: 'script',
      statusCode: {
        200(data) {
          decrementBadge();
          form.parents('li.order').html(data.responseText);
        },
        422(data) {
          form.parents('li.order').html(data.responseText);
        },
        500() {
          form.parents('li.order').html(I18n.t('feedback.error.message'));
        },
      },
    });
  }

  function decrementBadge() {
    Reverb.Badges.decrementBadge('feedback_badge');
  }

  function bindFeedbackDecline() {
    $(feedbackListContainer).on('ajax:success', '[data-bind=\'decline-leaving-feedback\']', removeFeedbackWrapper);
  }

  function removeFeedbackWrapper(e) {
    removeFeedback($(e.target));
  }

  function removeFeedback(link) {
    link.parents('li.feedback').fadeOut();
    decrementBadge();
  }

  function init() {
    bindFeedbackSubmit();
    bindRatyStarsDisplay();
    bindFeedbackDecline();
    bindMessageInput();
  }

  return {
    init,
    removeFeedback,
  };
}());

$(() => {
  Reverb.DashboardFeedback.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/feedback.js